import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';


import { fetchData } from '../utils/apiServices';
import { Header, ItemIcon, LoadingSpinner, NotAllowed, ToLink, UrlError } from './_Common';

import '../css/Studies.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const pageSubject = "חומרי לימוד";

const StudiesItem = ({ item, iconColor }) => {
    return (
        <div className="col" role="button">
            <ToLink to={item.link} target="_blank" className="text-decoration-none">
                <div className="d-flex align-items-center p-2 border rounded-4 shadow-lg bg-light hover-shadow parent-div">
                    <div className="me-4 icon-hover-effect-scale" style={{ color: iconColor }}>
                        <FontAwesomeIcon icon="fa-book-open" size="2x" className="icon-hover-effect" aria-label="Class studies" />
                    </div>
                    <div>
                        <span className="item-text text-dark">{item.name}</span>
                    </div>
                </div>
            </ToLink>
        </div>
    );
}
const StudiesFolder = ({ folder, itemIcon, handleOnClickFolder }) => {
    return (
        <div className="col" role="button" onClick={() => handleOnClickFolder(folder)}>
            <div className="d-flex align-items-center p-4 border rounded-4 shadow-lg bg-light hover-shadow">
                <div className="me-4">
                    {/* <div className="me-4" style={{ color: iconColor }}> */}
                    {/* <FontAwesomeIcon icon="fa-book" size="3x" className="" aria-label="Class studies" /> */}
                    <ItemIcon itemIcon={itemIcon} faClass="fa-2x" />
                </div>
                <div>
                    <p className="h4 mb-0 text-dark fw-semibold">{folder.name}</p>
                </div>
            </div>

        </div>
    );
}
const StudiesFolderItem = ({ folderItem }) => {
    return (
        <div className="col" role="button">
            <div className="d-flex align-items-center p-4 border rounded-4 shadow-lg bg-light hover-shadow">
                <ToLink to={folderItem.link} target="_blank" className="text-decoration-none d-flex align-items-center">
                    <div className="me-4">
                        <FontAwesomeIcon icon="fa-file" size="2x" className="FolderItem-color" />
                    </div>
                    <div>
                        <p className="h4 mb-0 text-dark fw-semibold">{folderItem.name}</p>
                    </div>
                </ToLink>
            </div>

        </div>
    );
}
function StudiesMainFolder({ mainFolders, selectedMainFolder, handleOnClickFolder }) {
    return (
        <div className="d-flex text-center border-top border-dark border-4 pt-2 hover-shadow" role="button">
            {mainFolders.map((mainFolder, index) => (
                <span className={`mx-2 ${selectedMainFolder && selectedMainFolder.id === mainFolder.id ? 'selected-MainFolder' : ''}`}
                    onClick={() => handleOnClickFolder(mainFolder)} key={index}>
                    <span className="album-color" ><ItemIcon itemIcon={mainFolder.itemIcon} /></span>
                    <span className="h5 mx-2">{mainFolder.name}</span>
                </span>
            ))}
        </div>
    );
}

export function StudiesForFolder() {
    //const folderId = localStorage.getItem('folderId');

    let { name: folderName } = useParams();
    folderName = decodeURIComponent(folderName);

    const [loading, setLoading] = useState(true);
    const [notAlowed, setNotAlowed] = useState(false);
    const [isUrlError, setIsUrlError] = useState(false);

    const [items, setItems] = useState([]);

    const iconColors = [
        '#FFCDD2', // Light Red
        '#C5CAE9', // Light Blue
        '#F8BBD0', // Light Pink
        '#B3E5FC', // Light Cyan
        '#E1BEE7', // Light Purple
        '#C8E6C9', // Light Green
        '#FFF9C4', // Light Yellow
    ];

    useEffect(() => {
        (async () => {
            const additionalHeaders = [{ name: 'folderName', value: encodeURIComponent(folderName) }];
            const { data: fetchedData, error, message } = await fetchData('/api/StudiesFilesForFolder', null, null, additionalHeaders);
            if (error && error === "Resource not found") {
                if (message && message === "URL Error")
                    setIsUrlError(true);
                else
                    setNotAlowed(true);
            }

            else setItems(fetchedData);

            setLoading(false);
        })();
    }, []);

    if (loading) { return <LoadingSpinner />; }
    if (notAlowed) { return <NotAllowed />; }
    if (isUrlError) { return <UrlError />; }
    const header = `${pageSubject} - ${folderName && folderName}`;
    const NotFound = `לא נמצאו ${pageSubject} עבור - ${folderName}`;
    return (
        <div className="">
            <Header header={header} titleCss="h4" />
            <div className="row row-cols-1 row-cols-md-3 g-4 py-3">
                {items && items.map((item, index) => (
                    <StudiesItem key={index} item={item} iconColor={iconColors[index % iconColors.length]} />
                ))}
                {items && items.length === 0 && <div className="h5">{NotFound}</div>}
            </div>
        </div>
    );
}
export default function Studies() {
    const [loading, setLoading] = useState(true);
    const [notAlowed, setNotAlowed] = useState(false);

    const [mainFolders, setMainFolders] = useState([]);
    const [selectedMainFolder, setSelectedMainFolder] = useState(null);

    const [folders, setFolders] = useState([]);
    const [folderItems, setFolderItems] = useState([]);

    useEffect(() => {
        (async () => {
            console.log("selectedMainFolder", selectedMainFolder);

            if (!selectedMainFolder) {
                const { data: fetchedDataFolder } = await fetchData('/api/Studies');
                setMainFolders(fetchedDataFolder);
                if (fetchedDataFolder) {
                    const defaultFolder = fetchedDataFolder.find(folder => folder.isDefault);
                    if (defaultFolder) setSelectedMainFolder(defaultFolder);
                    else if (fetchedDataFolder.length > 0) setSelectedMainFolder(fetchedDataFolder[0]);//if there's no default, select the first one
                    console.log(defaultFolder);
                }
            }
            if (selectedMainFolder) {
                const additionalHeaders = selectedMainFolder && [{ name: 'StudiesId', value: selectedMainFolder.id }];
                const { data: fetchedData, error, message } = await fetchData('/api/StudiesFolders', null, null, additionalHeaders);
                if (error && error === "Resource not found") setNotAlowed(true);
                else {
                    // Folders --> fetchData where fileType is "Dir"
                    setFolders(fetchedData.filter(folder => folder.fileType === "Dir"));
                    // FolderItems --> fetchData where fileType is not "Dir"
                    setFolderItems(fetchedData.filter(item => item.fileType !== "Dir"));
                }
            }

            setLoading(false);
        })();
    }, [selectedMainFolder]);

    const handleOnClickFolder = (folder) => {
        //localStorage.setItem('folderId', folder.link);
        const folderUrl = `/Studies/${encodeURIComponent(folder.name)}`;
        window.open(folderUrl, '_self');
    };
    if (loading || !folders || folders.length === 0) { return <LoadingSpinner />; }
    if (notAlowed) { return <NotAllowed />; }
    const header = `${selectedMainFolder && selectedMainFolder.name}`;
    return (
        <div className="">
            <Header header={header} titleCss="h4"  />
            <div className="row row-cols-1 row-cols-md-3 g-4 py-3">
                {folders && folders.map((folder, index) => (
                    <StudiesFolder key={index} folder={folder} itemIcon={selectedMainFolder.itemIcon} handleOnClickFolder={handleOnClickFolder} />
                ))}
                {folderItems && folderItems.length > 0 && folderItems.map((item, index) => (
                    <StudiesFolderItem key={index} folderItem={item} />
                ))}
            </div>
            {mainFolders && mainFolders.length > 1 && <StudiesMainFolder mainFolders={mainFolders} selectedMainFolder={selectedMainFolder} handleOnClickFolder={setSelectedMainFolder} />}
        </div>
    );
}